"use strict";
/**
 * @module Services.GatewayControl
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Gateway response from a get configuration request.
 */
var GetConfigurationResponse = /** @class */ (function () {
    /**
     * Create a new GetConfigurationResponse instance
     * @param type response type
     * @param schemaType the type of the schema (not currently used)
     * @param schema the schema data
     * @param config the config data
     */
    function GetConfigurationResponse(type, schemaType, schema, config) {
        this.type = type;
        this.config = config;
        this.schemaType = schemaType;
        this.schema = schema;
    }
    return GetConfigurationResponse;
}());
exports.GetConfigurationResponse = GetConfigurationResponse;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/gateway-control/get-configuration-response.js
// module id = 1947
// module chunks = 1